import "./pricing-table.scss";

import Button from "../../atoms/button/button";
import PricingTableProps from "./pricing-table.types";
import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const PricingTable = ({
  title,
  tags,
  richContent,
  btnText,
  btnLink,
  align = "left",
}: PricingTableProps) => {
  const classComponent = "pricingTable";
  const renderCell = (index, value, classNames) => (
    <td key={index} className={`${classComponent}__cell ${classNames}`}>
      {value}
    </td>
  );


  const options = {
    renderNode: {
      paragraph: (node, index) => (
        <p key={index} className={`${classComponent}__paragraph`}>
          {node.content[0]?.value}
          <strong>{node.content[1]?.value}</strong>
        </p>
      ),
      table: (node) => (
        <div className={`${classComponent}__tableContainer`}>
          <table className={`${classComponent}__table`}>
            <tbody>
              {node.content.map((row, rowIndex) => (
                <tr key={rowIndex} className={`${classComponent}__row`}>
                  {row.content.map((cell, cellIndex) => {
                    const content = cell.content[0].content[0];
                    const value = content.value.replace(/<([^>]*)>/, "");
                    const marks = content.marks.map((m) => m.type);
                    // get type of mark
                    const isFeatured =
                      marks.includes("bold") && marks.includes("underline");
                    const isUnderline = marks.includes("underline");
                    const isBold = marks.includes("bold");
                    // get Tooltip
                    const tooltip = content.value.match(/<([^>]*)>/)?.[1];
                    // set className
                    let className = `${classComponent}__cell`;

                    if (isFeatured) {
                      className += "--featured";
                    } else if (isUnderline) {
                      className += "--underline";
                    } else if (isBold) {
                      className += "--bold";
                    }

                    const spanElement = (
                      <span
                        className={`${classComponent}__tooltipComponent`}
                        {...(tooltip ? { title: tooltip } : {})}
                      >
                        {value}{" "}
                        {tooltip && (
                          <i className={`${classComponent}__tooltip`}>?</i>
                        )}
                      </span>
                    );
                    return renderCell(cellIndex, spanElement, className);
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ),
    },
  };

  return (
    <div className={`${classComponent} ${classComponent}--align-${align}`}>
      {title && <h2 className={`${classComponent}__title`}>{title}</h2>}
      {tags?.length && (
        <div className={`${classComponent}__tags`}>
          {tags.map((item, index) => (
            <span key={index} className={`${classComponent}__tag`}>
              {item}
            </span>
          ))}
        </div>
      )}
      {documentToReactComponents(JSON.parse(richContent?.raw), options)}
      {btnText && (
        <div className={`${classComponent}__button`}>
          <Button
            type="link"
            text={btnText}
            classname="secondary"
            isDisabled={false}
            href={btnLink}
          />
        </div>
      )}
    </div>
  );
};

export default PricingTable;
